import styled from '@emotion/styled';
import { mediaQuery, Spacings } from '@styles/index';
import {
  Filter,
  FilterInput,
  FilterList,
  FilterOption
} from 'aquilla/core/molecules/Filter';

const StyledFilterInput = styled(FilterInput)`
  width: 100%;
  padding: 7px ${Spacings.SPACING_4B};
  gap: ${Spacings.SPACING_2B};
  border: ${Spacings.SPACING_1} solid var(--color-i-divider);
`;

const StyFilterList = styled(FilterList)`
  z-index: 1;
  li:first-child a {
    display: none;
  }
  ${mediaQuery.uptoMobile} {
    display: none;
  }
`;

const JumpToWeekWrapper = styled.div`
  ${mediaQuery.uptoMobile} {
    display: none;
  }
`;

const FilterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${Spacings.SPACING_4B};
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_3B};
  }
`;

const JumpToWeek = ({
  handleClick,
  selectedWeek,
  handleJumpToWeek,
  weekDetails
}) => {
  return (
    <JumpToWeekWrapper>
      <FilterWrapper onClick={handleClick()}>
        <Filter
          value={selectedWeek ? `Week ${selectedWeek}` : 'Jump to week'}
          onSelect={handleJumpToWeek}
        >
          <StyledFilterInput />
          <StyFilterList>
            {weekDetails.map((weekObj) => (
              <FilterOption
                value={weekObj.weekNumber}
                label={weekObj.weekLabel}
                key={weekObj.weekNumber}
              />
            ))}
          </StyFilterList>
        </Filter>
      </FilterWrapper>
    </JumpToWeekWrapper>
  );
};

export default JumpToWeek;
